import { Skeleton } from '@sea-snag/ui';
import { createFileRoute } from '@tanstack/react-router';

import { IncomePage } from '../../components/income/income-page';
import { useRequiredOrganization } from '../../hooks/use-required-organization';
import { useYear } from '../../hooks/use-year';

export const Route = createFileRoute('/$orgPid/analytics/income')({
  component: AnalyticsIncomeTab,
});

function AnalyticsIncomeTab() {
  const { organization, isLoading } = useRequiredOrganization();
  const year = useYear();
  const orgPid = organization?.pid ?? '';

  if (isLoading || !orgPid) return <Skeleton className="h-[600px] w-full" />;
  return <IncomePage orgPid={orgPid} year={year} />;
}
